import { useEffect, useRef } from 'react';
import { Box } from '@mantine/core';
import { useLocation } from 'react-router';

import { SidePanelController } from '@ayocore/platform/client/layouts/side_panel/SidePanelController';
import { useAuthController } from '../useAuthController';
import { UserProfileView } from './UserProfileView';

/**
 * Dock-компонент профиля текущего пользователя.
 * Показывает UserProfileView для залогиненного юзера.
 * При смене роута (например клик "Редактировать") — сворачивает панель.
 */
export function ProfileDockPanel() {
  const { user } = useAuthController();
  const location = useLocation();
  const initialPath = useRef(location.pathname);

  useEffect(() => {
    if (location.pathname !== initialPath.current) {
      SidePanelController.getInstance().closePanel();
    }
  }, [location.pathname]);

  if (!user) return null;

  return (
    <Box p='md'>
      <UserProfileView userId={user.id} isModal />
    </Box>
  );
}
